import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {PagingModel} from '../models/paging-model';

@Component({
  selector: 'paging-footer',
  template: `<div class="row">
      <div class="col-md-12" *ngIf="totalPages > 1">
          <nav>
              <ul class="pagination pull-right">
                  <li class="page-item" [ngClass]="{'disabled': pageNumber === 1}">
                    <a class="page-link" (click)="changePage(pageNumber - 1)">
                      <span>Previous</span>
                    </a>
                  </li>
                  <li class="page-item" [ngClass]="{'active': pageNumber === p}" *ngFor="let p of pages">
                    <a class="page-link" (click)="changePage(p)">{{p}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled': pageNumber === totalPages}" >
                    <a class="page-link" (click)="changePage(pageNumber + 1)">
                      <span>Next</span>
                    </a>
                  </li>
              </ul>
          </nav>
      </div>
  </div>`
})
export class PagingFooterComponent implements OnChanges {
  @Input() paging: PagingModel;
  @Output() pageChanged: EventEmitter<PagingModel> = new EventEmitter();
  public pages: number[];

  get pageNumber () {
    return this.paging.pageNumber;
  }

  get totalPages () {
    return this.paging.totalPages;
  }
  constructor() { }

  changePage (newPageNumber: number) {
    const newPaging = Object.assign({}, this.paging);
    newPaging.pageNumber = newPageNumber;
    this.pageChanged.emit(newPaging);
  }

  ngOnChanges() {
    this.pages = [];
    let firstPageNumber = this.pageNumber - 5;
    if (firstPageNumber + 10 > this.totalPages) {
      firstPageNumber = this.totalPages - 10;
    }
    if (firstPageNumber <= 0) {
      firstPageNumber = 1;
    }
    for (let i = 0; i <= 10; i++) {
      if (i + firstPageNumber <= this.totalPages) {
        this.pages.push(i + firstPageNumber);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/paging-footer.ts